export const phoneNumber: RegExp = /^[()\-+0-9]+$/
export const currencyInput: RegExp = /[a-zA-Z,\\/!@#$%^&*()_~]/g
export const percentInput: RegExp = /[a-zA-Z,\\/!@#$%^&*()_~]/g
export const numberInput: RegExp = /[a-zA-Z,\\/!@#$%^&*()_~]/g
export const multipleDotsPattern: RegExp = /\..*\./
export const currencyFormatter: RegExp = /(\d)(?=(\d{3})+(?!\d))/g
export const bankAccountInput: RegExp = /^[1-9]\d{0,12}$/
export const postcodeInput: RegExp = /^[1-9]\d{0,3}$/
export const onlyNumbers: RegExp = /[^0-9]/g
export const isGuid: RegExp =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/g
